import type { ContextPillIconType } from './types';

export function mimeTypeToIconType(mimeType: string): ContextPillIconType {
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.startsWith('video/')) return 'video';
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType === 'application/msword' || mimeType.includes('wordprocessingml')) return 'doc';

  return 'file';
}
